<template>
  <div>
    <HeroSection showCallbackModal>
      <template #heading>
        {{ $t('landingPageIv24.hero.title') }}
      </template>
      <template #description>
        {{ $t('landingPageIv24.hero.description') }}
      </template>
      <template #headline>
        {{ $t('landingPageIv24.hero.headline') }}
      </template>
    </HeroSection>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

import HeroSection from '@/components/local-landing-page/HeroSection/HeroSection.vue';
import { useTrackingWithTreatment } from '@/composables/useTrackingWithTreatment';

// Composables
const { t, locale } = useI18n();
const { trackVirtualPageViewWithTreatment } = useTrackingWithTreatment();

// Methods extracted from mixins
const getPageTitle = (): string => {
  return t('metaInfo.title') as string;
};

const getPageDescription = (): string => {
  return t('metaInfo.description') as string;
};

// Head metadata
useHead(() => {
  const metaTags = [
    { name: 'description', content: getPageDescription() },
    { name: 'robots', content: 'noindex, nofollow' },
  ];

  return {
    title: getPageTitle(),
    htmlAttrs: {
      lang: locale.value,
    },
    meta: metaTags,
  };
});

// Lifecycle
onMounted(() => {
  trackVirtualPageViewWithTreatment({
    subType: 'landingpage',
    locale: locale.value,
    stepInputs: '',
  });
});
</script>

<style lang="scss" scoped>
@use '@/assets/variables' as *;

.landing-content {
  > div,
  > section {
    margin-bottom: $space-500;
  }
}
</style>
